import React from 'react';
import { FileUploadButton, ImageDropzone } from 'react-file-utils';
import { EmojiPicker } from './EmojiPicker';
import { CooldownTimer as DefaultCooldownTimer } from './hooks/useCooldownTimer';
import { EmojiIconSmall as DefaultEmojiIcon, FileUploadIcon as DefaultFileUploadIcon, SendButton as DefaultSendButton, } from './icons';
import { UploadsPreview } from './UploadsPreview';
import { ChatAutoComplete } from '../ChatAutoComplete/ChatAutoComplete';
import { Tooltip } from '../Tooltip/Tooltip';
import { useChannelStateContext } from '../../context/ChannelStateContext';
import { useChatContext } from '../../context/ChatContext';
import { useTranslationContext } from '../../context/TranslationContext';
import { useTypingContext } from '../../context/TypingContext';
import { useMessageInputContext } from '../../context/MessageInputContext';
import { useComponentContext } from '../../context/ComponentContext';
/**
 * @deprecated - This UI component will be removed in the next major release.
 */
export var MessageInputLarge = function () {
    var _a = useChannelStateContext(), acceptedFiles = _a.acceptedFiles, multipleUploads = _a.multipleUploads, watcher_count = _a.watcher_count;
    var client = useChatContext().client;
    var t = useTranslationContext().t;
    var typing = useTypingContext().typing;
    var _b = useMessageInputContext(), closeEmojiPicker = _b.closeEmojiPicker, cooldownInterval = _b.cooldownInterval, cooldownRemaining = _b.cooldownRemaining, emojiPickerIsOpen = _b.emojiPickerIsOpen, emojiPickerRef = _b.emojiPickerRef, handleEmojiKeyDown = _b.handleEmojiKeyDown, handleSubmit = _b.handleSubmit, isUploadEnabled = _b.isUploadEnabled, maxFilesLeft = _b.maxFilesLeft, openEmojiPicker = _b.openEmojiPicker, setCooldownRemaining = _b.setCooldownRemaining, uploadNewFiles = _b.uploadNewFiles;
    var _c = useComponentContext(), _d = _c.CooldownTimer, CooldownTimer = _d === void 0 ? DefaultCooldownTimer : _d, _e = _c.EmojiIcon, EmojiIcon = _e === void 0 ? DefaultEmojiIcon : _e, _f = _c.FileUploadIcon, FileUploadIcon = _f === void 0 ? DefaultFileUploadIcon : _f, _g = _c.SendButton, SendButton = _g === void 0 ? DefaultSendButton : _g;
    var constructTypingString = function (typingUsers) {
        var otherTypingUsers = Object.values(typingUsers)
            .filter(function (_a) {
            var _b;
            var user = _a.user;
            return ((_b = client.user) === null || _b === void 0 ? void 0 : _b.id) !== (user === null || user === void 0 ? void 0 : user.id);
        })
            .map(function (_a) {
            var user = _a.user;
            return (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.id);
        });
        if (otherTypingUsers.length === 0)
            return '';
        if (otherTypingUsers.length === 1) {
            return t('{{ user }} is typing...', { user: otherTypingUsers[0] });
        }
        if (otherTypingUsers.length === 2) {
            // joins all with "and" but =no commas
            // example: "bob and sam"
            return t('{{ firstUser }} and {{ secondUser }} are typing...', {
                firstUser: otherTypingUsers[0],
                secondUser: otherTypingUsers[1],
            });
        }
        // joins all with commas, but last one gets ", and" (oxford comma!)
        // example: "bob, joe, and sam"
        return t('{{ commaSeparatedUsers }} and {{ lastUser }} are typing...', {
            commaSeparatedUsers: otherTypingUsers.slice(0, -1).join(', '),
            lastUser: otherTypingUsers[otherTypingUsers.length - 1],
        });
    };
    return (React.createElement("div", { className: 'str-chat__input-large' },
        React.createElement(ImageDropzone, { accept: acceptedFiles, disabled: !isUploadEnabled || maxFilesLeft === 0 || !!cooldownRemaining, handleFiles: uploadNewFiles, maxNumberOfFiles: maxFilesLeft, multiple: multipleUploads },
            React.createElement("div", { className: 'str-chat__input' },
                React.createElement("div", { className: 'str-chat__input--textarea-wrapper' },
                    isUploadEnabled && React.createElement(UploadsPreview, null),
                    React.createElement(ChatAutoComplete, null),
                    cooldownRemaining ? (React.createElement("div", { className: 'str-chat__input-large-cooldown' },
                        React.createElement(CooldownTimer, { cooldownInterval: cooldownInterval, setCooldownRemaining: setCooldownRemaining }))) : (React.createElement(React.Fragment, null,
                        isUploadEnabled && (React.createElement("div", { className: 'str-chat__fileupload-wrapper', "data-testid": 'fileinput' },
                            React.createElement(Tooltip, null, maxFilesLeft
                                ? t('Attach files')
                                : t("You've reached the maximum number of files")),
                            React.createElement(FileUploadButton, { accepts: acceptedFiles, disabled: maxFilesLeft === 0, handleFiles: uploadNewFiles, multiple: multipleUploads },
                                React.createElement("span", { className: 'str-chat__input-fileupload' },
                                    React.createElement(FileUploadIcon, null))))),
                        React.createElement("div", { className: 'str-chat__emojiselect-wrapper' },
                            React.createElement(Tooltip, null, emojiPickerIsOpen ? t('Close emoji picker') : t('Open emoji picker')),
                            React.createElement("span", { className: 'str-chat__input-emojiselect', onClick: emojiPickerIsOpen ? closeEmojiPicker : openEmojiPicker, onKeyDown: handleEmojiKeyDown, ref: emojiPickerRef, role: 'button', tabIndex: 0 },
                                React.createElement(EmojiIcon, null))))),
                    React.createElement(EmojiPicker, null)),
                !cooldownRemaining && React.createElement(SendButton, { sendMessage: handleSubmit })),
            React.createElement("div", null,
                React.createElement("div", { className: 'str-chat__input-footer' },
                    React.createElement("span", { className: "str-chat__input-footer--count " + (!watcher_count ? 'str-chat__input-footer--count--hidden' : '') }, t('{{ watcherCount }} online', {
                        watcherCount: watcher_count,
                    })),
                    React.createElement("span", { className: 'str-chat__input-footer--typing' }, constructTypingString(typing || {})))))));
};
